import { NoteDialog } from './NoteDialog'

interface Props {
  open: boolean
  onClose: () => void
  /** 送れなかったら reject する。dialog は閉じず、書いた文章を残す */
  onSubmit: (note: string) => Promise<void>
}

/**
 * 改善依頼の dialog。文章 1 欄だけで、説明文は置かない (log/63 D4)。
 * 器は `NoteDialog`(遠隔入力の一言・申し送りと同じ形)。改善依頼は空では送れない。
 */
export const FeedbackDialog = (props: Props) => (
  <NoteDialog
    {...props}
    title="改善依頼"
    placeholder="レセコンでどう入ったか、こう読んでほしい、など"
    confirmLabel="送信"
  />
)
